import { PreviousEmploymentDetailsNew_MX } from './mixed';

export const PreviousEmploymentDetailsFormNew = {
  /**
   * PrivateLease
   */
  PL: PreviousEmploymentDetailsNew_MX,
};
